export const TOGGLE_AUDIO_STATE = "TOGGLE_AUDIO_STATE"

const initialState: any =  {
  mute: false,
};
const audioRedux = (state = initialState, action: any): any => {
  switch (action.type) {
    case TOGGLE_AUDIO_STATE: {
        state.mute = !state.mute
      return state
    }
    default: {
      return state;
    }
  }
};

export default audioRedux;
